import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyChdmYutT4D-1ez_x6EuwN5XTEuwi_fepQ",
  authDomain: "werkstate.firebaseapp.com",
  projectId: "werkstate",
  storageBucket: "werkstate.firebasestorage.app",
  messagingSenderId: "394336168640",
  appId: "1:394336168640:web:9e15f7d9d86cf2677ddb25",
  measurementId: "G-MGM9W0ZRT6",
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const functions = getFunctions(app, "europe-west3");

// App Check Phase A (instrument only — Console enforcement stays off).
// Set VITE_RECAPTCHA_SITE_KEY to a reCAPTCHA v3 site key when ready.
const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY as string | undefined;
if (typeof recaptchaSiteKey === "string" && recaptchaSiteKey.trim().length > 0) {
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(recaptchaSiteKey.trim()),
    isTokenAutoRefreshEnabled: true,
  });
}
// else: skip App Check until the site key is configured (see docs/security/app-check.md).

if (import.meta.env.DEV && import.meta.env.VITE_USE_EMULATORS === "true") {
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
  connectAuthEmulator(auth, "http://127.0.0.1:9099");
}
